<script>
import wavyLine from '../components/wavy-line.vue';
import searchRiverwatch from '../components/search-form.vue';
import liquidBackground from '../components/liquid-background.vue';

export default {
    components: {
        searchRiverwatch,
        wavyLine,
        liquidBackground
    },

    data() {
        return {
            focused: false,
            isAnimating: false,
            isOpen: false
        };
    },

    mounted() {
        if (this.$root.searchOpen === true) {
            this.open();
        }
    },

    methods: {
        open() {
            document.querySelector('html, body').classList.add('overflow-hidden');
            this.$refs.modal.classList.remove('opacity-0');
            document.addEventListener('keyup', this.escapeClose);

            this.isOpen = true;
            this.$refs.liquid.toggle();
        },

        liquidResponse() {
            if (this.isOpen) {
                this.animateIn();
            } else {
                this.close();
            }
        },

        animateIn() {
            /* :: Set the Stage
            {+} ---------------------------------- */
            this.$refs.categories.classList.remove('invisible', 'opacity-0');
            this.$refs.searchForm.classList.remove('invisible');
            this.$refs.close.classList.remove('invisible');
            this.$refs.footer.classList.remove('invisible');

            const searchIn = greensock.timeline();

            searchIn
                .fromTo(
                    this.$refs.searchForm,
                    {
                        y: '6rem'
                    },
                    {
                        y: '0',
                        opacity: 1,
                        duration: 0.5,
                        delay: 0.2,
                        ease: 'circ.out'
                    }
                )
                .fromTo(
                    this.$refs.text,
                    {
                        y: '3rem'
                    },
                    {
                        y: '0',
                        opacity: 1,
                        duration: 0.4,
                        ease: 'circ.out'
                    },
                    '>-0.2'
                )
                .to(
                    this.$refs.footer,
                    {
                        opacity: 1,
                        duration: 0.4,
                        ease: 'power1.out'
                    },
                    '<0.2'
                )
                .to(
                    this.$refs.close,
                    {
                        opacity: 1,
                        duration: 0.4,
                        ease: 'power1.out'
                    },
                    '>-0.2'
                );

            this.categoryIn(this.$refs.coverContainer1, this.$refs.coverBase1, this.$refs.coverShape1, 0.32);

            this.categoryIn(this.$refs.coverContainer2, this.$refs.coverBase2, this.$refs.coverShape2, 0.4);

            this.categoryIn(this.$refs.coverContainer3, this.$refs.coverBase3, this.$refs.coverShape3, 0.48);

            this.categoryIn(this.$refs.coverContainer4, this.$refs.coverBase4, this.$refs.coverShape4, 0.56);
        },

        categoryIn(container, coverBase, coverShape, delay) {
            const categoryIn = greensock.timeline();

            categoryIn
                .fromTo(
                    coverShape,
                    {
                        y: '104%'
                    },
                    {
                        y: '0',
                        duration: 0.64,
                        delay: delay,
                        ease: 'circ.inOut'
                    }
                )
                .set(coverBase, { opacity: 0 })
                .to(coverShape, {
                    opacity: 0,
                    duration: 0.5,
                    ease: 'power1.out',
                    onComplete: () => {
                        container.classList.add('opacity-0', 'invisible');
                    }
                });
        },

        animateOut() {
            this.$root.$emit('cursorClick');

            if (!this.isAnimating) {
                this.isAnimating = true;

                this.categoryOut(this.$refs.coverContainer1, this.$refs.coverBase1, this.$refs.coverShape1, 0);

                this.categoryOut(this.$refs.coverContainer2, this.$refs.coverBase2, this.$refs.coverShape2, 0.16);

                this.categoryOut(this.$refs.coverContainer3, this.$refs.coverBase3, this.$refs.coverShape3, 0.32);

                this.categoryOut(this.$refs.coverContainer4, this.$refs.coverBase4, this.$refs.coverShape4, 0.48);

                const searchOut = greensock.timeline();

                searchOut
                    .to(this.$refs.searchForm, {
                        y: '-6rem',
                        opacity: 0,
                        duration: 0.5,
                        ease: 'circ.out'
                    })
                    .to(
                        this.$refs.text,
                        {
                            y: '-3',
                            opacity: 0,
                            duration: 0.4,
                            ease: 'circ.out'
                        },
                        '>-0.2'
                    )
                    .to(
                        this.$refs.footer,
                        {
                            opacity: 0,
                            duration: 0.4,
                            ease: 'power1.out'
                        },
                        '<0.2'
                    )
                    .to(
                        this.$refs.close,
                        {
                            opacity: 0,
                            duration: 0.4,
                            ease: 'power1.out',
                            onComplete: () => {
                                /* :: Reset the Stage
                                {+} ---------------------------------- */
                                this.$refs.categories.classList.add('invisible', 'opacity-0');
                                this.$refs.searchForm.classList.add('invisible');
                                this.$refs.close.classList.add('invisible');
                                this.$refs.footer.classList.add('invisible');

                                this.isOpen = false;
                                this.$refs.liquid.toggle();
                                this.isAnimating = false;
                            }
                        },
                        '>0.2'
                    );
            }
        },

        categoryOut(container, coverBase, coverShape, delay) {
            const categoryIn = greensock.timeline();
            container.classList.remove('opacity-0', 'invisible');

            categoryIn
                .to(coverShape, {
                    opacity: 1,
                    duration: 0.32,
                    delay: delay,
                    ease: 'power1.out'
                })
                .set(coverBase, { opacity: 1 })
                .to(coverShape, {
                    y: '104%',
                    duration: 0.64,
                    ease: 'circ.inOut'
                });
        },

        close() {
            document.removeEventListener('keyup', this.escapeClose);
            document.querySelector('html, body').classList.remove('overflow-hidden');
            this.$root.searchOpen = false;
        },

        escapeClose(event) {
            if (event.keyCode === 27) {
                this.animateOut();
            }
        },

        magnetizeMe(ev, element, force) {
            magnitize.start(ev, this.$el, element, force);
        },

        deMagnetize(element) {
            this.$root.$emit('cursorLeave');
            magnitize.stop(element);
        }
    }
};
</script>
